// Utilidades matemáticas puras (sin three.js) del pack de movimiento.
export const DEG = Math.PI / 180;
export const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
export const lerp = (a, b, t) => a + (b - a) * t;
export const smoothstep = (t) => { const x = clamp(t, 0, 1); return x * x * (3 - 2 * x); };

/**
 * Curva periódica (ciclo 0..1) que pasa por puntos clave [[fase, valor], ...].
 * Interpolación de Hermite con tangentes por diferencias finitas: suave, sin saltos al cerrar el ciclo.
 */
export function periodic(keys) {
  const n = keys.length;
  const p = keys.map((k) => k[0]);
  const v = keys.map((k) => k[1]);
  const P = (i) => p[((i % n) + n) % n] + Math.floor(i / n);
  const V = (i) => v[((i % n) + n) % n];
  const tan = (i) => (V(i + 1) - V(i - 1)) / (P(i + 1) - P(i - 1));
  return (phase) => {
    let x = phase - Math.floor(phase);
    if (x < p[0]) x += 1;
    let i = 0;
    while (i < n - 1 && x >= p[i + 1]) i++;
    const x0 = P(i);
    const h = P(i + 1) - x0;
    const s = (x - x0) / h;
    const s2 = s * s;
    const s3 = s2 * s;
    return (2 * s3 - 3 * s2 + 1) * V(i) + (s3 - 2 * s2 + s) * h * tan(i)
      + (-2 * s3 + 3 * s2) * V(i + 1) + (s3 - s2) * h * tan(i + 1);
  };
}

const hash = (n) => { const s = Math.sin(n * 127.1 + 311.7) * 43758.5453; return s - Math.floor(s); };

/** Ruido de valor 1D, determinista, en [-1, 1]. */
export function noise1(t, seed = 0) {
  const i = Math.floor(t);
  const f = t - i;
  const a = hash(i + seed * 17.3);
  const b = hash(i + 1 + seed * 17.3);
  return (a + (b - a) * smoothstep(f)) * 2 - 1;
}

/** Número pseudoaleatorio determinista en [0, 1) a partir de un entero. */
export const rand01 = (n, seed = 0) => hash(n * 3.7 + seed * 91.3);
